import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';

import type { FieldListItem } from './FieldList';
import { FieldList } from './FieldList';

export interface FieldListPanelProps {
  fieldSearch: string;
  fieldListItems: FieldListItem[];
  selectedFieldKey: string | null;
  isLoading: boolean;
  isError: boolean;
  onSelectField: (key: string) => void;
  onFieldSearchChange: (value: string) => void;
}

export const FieldListPanel = ({
  fieldSearch,
  fieldListItems,
  selectedFieldKey,
  isLoading,
  isError,
  onSelectField,
  onFieldSearchChange,
}: FieldListPanelProps) => {
  const { t } = useLingui();

  return (
    <div className="vai-w-1/2 vai-min-w-0 vai-flex vai-flex-col vai-rounded-md vai-border vai-border-gray-200 vai-bg-white vai-overflow-hidden">
      <div className="vai-flex vai-items-center vai-gap-2 vai-m-3 vai-pb-2 vai-border-b vai-border-gray-200">
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className="vai-shrink-0 vai-text-gray-400 vai-h-4 vai-w-4"
        />
        <input
          type="text"
          placeholder={t`Search fields or values...`}
          value={fieldSearch}
          onChange={(e) => onFieldSearchChange(e.target.value)}
          className="vai-min-w-0 vai-flex-1 vai-py-1 vai-text-sm focus:vai-outline-none vai-border-0 vai-bg-transparent"
        />
      </div>
      <div className="vai-flex-1 vai-overflow-y-auto">
        {isError ? (
          <div className="vai-p-4 vai-text-sm vai-text-red-500">
            <Trans>Error loading fields</Trans>
          </div>
        ) : isLoading ? (
          <div className="vai-p-4 vai-text-sm vai-text-gray-500">
            <Trans>Loading...</Trans>
          </div>
        ) : fieldListItems.length === 0 ? (
          <div className="vai-p-4 vai-text-sm vai-text-gray-500">
            <Trans>No fields found.</Trans>
          </div>
        ) : (
          <FieldList
            fields={fieldListItems}
            selectedFieldKey={selectedFieldKey}
            onSelectField={onSelectField}
          />
        )}
      </div>
    </div>
  );
};
